module.exports = __webpack_public_path__ + "static/img/limit_white_08.00a02690.svg";